var map = {
	"./Bellavista.svg": "a934",
	"./Carabaya.svg": "efa8",
	"./Chiclayo.svg": "fb31",
	"./Crillon.svg": "a4ea",
	"./Fenix.svg": "d2df",
	"./Lima_cargo.svg": "a207",
	"./Piura.svg": "d03d",
	"./Surquillo.svg": "eb97",
	"./Trujillo.svg": "2428"
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = "b114";